// imports
import React from 'react';
import clsx from 'clsx';

// interfaces / types / consts
interface Props { fold?: boolean; flip?: boolean }

// exports
export default function PaperBG(props: Props): JSX.Element {
  const { fold, flip } = props;
  return (<div className={clsx('paper-bg', fold && 'fold', flip && 'flip')} />);
}

// default props
PaperBG.defaultProps = { fold: false, flip: false };
